<template>
  <v-container class="mt-4 ml-2 textoPoppins" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="pb-0 flex-wrap">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Agentes IA · Vendedor</div>
              <div class="text-caption grey--text">
                Hito 21 · versionado API · sin asignar tráfico CRM
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn small text :to="{ name: 'twilioSandbox' }">
              <v-icon left small>mdi-whatsapp</v-icon>
              Sandbox
            </v-btn>
            <v-btn small text class="ml-1" :to="{ name: 'vendedorIaComercial' }">
              <v-icon left small>mdi-store-cog</v-icon>
              Comercial
            </v-btn>
            <v-btn small color="primary" class="ml-2" :loading="cargando" @click="cargarListado">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            <v-btn small color="success" class="ml-2" dark @click="abrirNuevo">
              <v-icon left small>mdi-plus</v-icon>
              Nuevo
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-alert v-if="status" dense outlined type="info" class="mb-3">
              <span class="text-caption">
                Entorno: <strong>{{ status.entorno }}</strong>
                · BD: <strong>{{ status.db_twilio }}</strong>
                · Runtime versionado:
                <strong>{{ status.runtime_versionado ? 'ON' : 'OFF' }}</strong>
                ({{ status.flag }})
              </span>
            </v-alert>
            <v-alert v-if="error" dense type="error" class="mb-3" dismissible @input="error = null">
              {{ error }}
            </v-alert>

            <v-data-table
              :headers="headers"
              :items="agentes"
              dense
              :loading="cargando"
              class="elevation-0"
              @click:row="abrirAgente"
            >
              <template v-slot:item.estado_agente="{ item }">
                <v-chip x-small :color="chipEstado(item.estado_agente)" dark>
                  {{ item.estado_agente || (item.activo ? 'activo' : 'inactivo') }}
                </v-chip>
              </template>
              <template v-slot:item.version="{ item }">
                <span class="text-caption">
                  {{ item.version_publicada ? item.version_publicada.numero_version : '—' }}
                </span>
              </template>
              <template v-slot:item.regiones="{ item }">
                <span class="text-caption">
                  {{ regionesTexto(item) }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon small @click.stop="abrirAgente(item)" title="Editar">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click.stop="abrirCopiar(item)" title="Copiar agente">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.estado_agente === 'inactivo'"
                  icon
                  small
                  color="success"
                  @click.stop="activar(item)"
                  title="Activar"
                >
                  <v-icon small>mdi-play-circle</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="orange"
                  :disabled="item.estado_agente === 'archivado'"
                  @click.stop="desactivar(item)"
                  title="Desactivar"
                >
                  <v-icon small>mdi-pause-circle</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- NUEVO AGENTE -->
    <v-dialog v-model="dlgNuevo" max-width="520" persistent>
      <v-card>
        <v-card-title>Nuevo agente</v-card-title>
        <v-card-text>
          <v-text-field v-model="formNuevo.id_agente" label="id_agente *" dense outlined hide-details class="mb-3" />
          <v-text-field v-model="formNuevo.nombre_publico" label="Nombre público *" dense outlined hide-details class="mb-3" />
          <v-text-field v-model="formNuevo.cargo" label="Cargo" dense outlined hide-details class="mb-3" />
          <v-radio-group v-model="formNuevo.marca" row dense hide-details class="mb-2">
            <v-radio label="INBI" value="INBI" />
            <v-radio label="FAST" value="FAST" />
          </v-radio-group>
          <v-select
            v-model="formNuevo.regiones"
            :items="opcionesRegiones"
            label="Regiones"
            multiple
            dense
            outlined
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgNuevo = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="crearAgente">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- COPIAR AGENTE -->
    <v-dialog v-model="dlgCopiar" max-width="560" persistent>
      <v-card>
        <v-card-title>Copiar agente</v-card-title>
        <v-card-text>
          <div class="text-caption grey--text mb-2" v-if="copiarOrigen">
            Origen: <strong>{{ copiarOrigen.id_agente }}</strong>
            ({{ copiarOrigen.nombre_publico }})
          </div>
          <v-text-field
            v-model="formCopiar.id_agente_nuevo"
            label="Nuevo id_agente"
            dense
            outlined
            hide-details
            class="mb-3"
            hint="Ej. INBI_ASESORA_SOFIA"
          />
          <v-text-field
            v-model="formCopiar.nombre_publico"
            label="Nombre público"
            dense
            outlined
            hide-details
            class="mb-3"
          />
          <div class="text-caption font-weight-bold mb-1">Secciones a copiar</div>
          <v-btn x-small text class="mb-1" @click="seleccionarTodasSecciones(true)">Todas</v-btn>
          <v-btn x-small text class="mb-1" @click="seleccionarTodasSecciones(false)">Ninguna</v-btn>
          <v-row dense>
            <v-col v-for="s in seccionesClon" :key="s" cols="6">
              <v-checkbox
                v-model="formCopiar.secciones"
                :label="s"
                :value="s"
                dense
                hide-details
                class="mt-0"
              />
            </v-col>
          </v-row>
          <v-alert dense outlined type="info" class="mt-3 text-caption">
            No se copian conversaciones, métricas, auditoría ni estado publicado.
            El nuevo agente nace en borrador v1.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgCopiar = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="ejecutarCopiar">
            Copiar agente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- EDITOR -->
    <v-dialog v-model="dlgEditor" max-width="960" scrollable persistent>
      <v-card v-if="agenteActivo">
        <v-card-title class="pb-1">
          <div>
            <div class="text-subtitle-1 font-weight-bold">{{ agenteActivo.nombre_publico }}</div>
            <div class="text-caption grey--text">
              {{ agenteActivo.id_agente }} · marca {{ agenteActivo.marca }}
              · publicada v{{ agenteActivo.version_publicada && agenteActivo.version_publicada.numero_version || '—' }}
            </div>
          </div>
          <v-spacer />
          <v-chip x-small class="mr-2" :color="chipEstado(agenteActivo.estado_agente)" dark>
            {{ agenteActivo.estado_agente }}
          </v-chip>
          <v-btn icon @click="cerrarEditor"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text style="max-height: 70vh">
          <v-alert dense outlined type="warning" class="mb-3 text-caption">
            El tráfico lo asigna el CRM. Publicar solo afecta conversaciones/contactos nuevos.
            Núcleo del sistema: solo lectura.
          </v-alert>

          <div class="d-flex align-center mb-3 flex-wrap">
            <span class="text-caption mr-2">Versión editando:</span>
            <v-select
              v-model="numeroEdit"
              :items="versionesSelect"
              dense
              outlined
              hide-details
              style="max-width: 220px"
              class="mr-2"
            />
            <v-chip x-small class="mr-2" :color="chipEstado(versionEdit && versionEdit.estado_version)" dark>
              {{ (versionEdit && versionEdit.estado_version) || '—' }}
            </v-chip>
            <v-btn small outlined :loading="guardando" @click="crearVersion">
              <v-icon left small>mdi-source-branch</v-icon>
              Nueva versión
            </v-btn>
          </div>

          <v-tabs v-model="tab" background-color="transparent" grow>
            <v-tab>Identidad</v-tab>
            <v-tab>Alcance</v-tab>
            <v-tab>Prompts</v-tab>
            <v-tab>Modo</v-tab>
            <v-tab>Tools</v-tab>
            <v-tab>Modelo</v-tab>
            <v-tab>Pruebas</v-tab>
            <v-tab>Publicación</v-tab>
            <v-tab>Auditoría</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" class="mt-3">
            <v-tab-item>
              <v-text-field v-model="form.nombre_publico" label="Nombre público" dense outlined :disabled="!editable" class="mb-2" />
              <v-text-field v-model="form.cargo" label="Cargo" dense outlined :disabled="!editable" class="mb-2" />
              <v-row dense>
                <v-col cols="6" md="4">
                  <v-select v-model="form.personalidad.tono" :items="opcionesTono" label="Tono" dense outlined :disabled="!editable" />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select v-model="form.personalidad.formalidad" :items="opcionesNivel" label="Formalidad" dense outlined :disabled="!editable" />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select v-model="form.personalidad.uso_emojis" :items="opcionesEmojis" label="Emojis" dense outlined :disabled="!editable" />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select v-model="form.personalidad.longitud_respuesta" :items="opcionesLongitud" label="Longitud" dense outlined :disabled="!editable" />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select v-model="form.personalidad.estilo_venta" :items="opcionesEstilo" label="Estilo venta" dense outlined :disabled="!editable" />
                </v-col>
              </v-row>
              <v-textarea
                v-model="form.personalidad.instrucciones_escritura"
                label="Mini prompt de escritura"
                hint="Instrucciones libres para redactar mensajes al prospecto (ej. “sé muy amigable”, “escribe más largo”, “actúa como un coach”). Se aplican al generar y naturalizar cada mensaje."
                persistent-hint
                dense
                outlined
                rows="3"
                auto-grow
                counter="800"
                :disabled="!editable"
                class="mt-2 mb-2"
                @input="recortarMiniPrompt"
              />
              <v-btn color="primary" small class="mt-2" :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-radio-group v-model="form.alcance.marca" row dense :disabled="!editable">
                <v-radio label="INBI" value="INBI" />
                <v-radio label="FAST" value="FAST" />
              </v-radio-group>
              <v-select
                v-model="form.alcance.regiones"
                :items="opcionesRegiones"
                label="Regiones"
                multiple
                dense
                outlined
                :disabled="!editable"
                class="mb-2"
              />
              <div class="text-caption grey--text mb-2">
                MVP: solo marca + regiones. Programas/números WhatsApp → fases posteriores.
              </div>
              <v-btn color="primary" small :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <div class="d-flex align-center flex-wrap mb-2" style="gap: 8px">
                <v-btn small outlined color="primary" @click="exportarPromptsMd">
                  <v-icon left small>mdi-download</v-icon>
                  Descargar .md
                </v-btn>
                <v-btn
                  small
                  outlined
                  color="indigo"
                  :disabled="!editable"
                  @click="triggerImportarPromptsMd"
                >
                  <v-icon left small>mdi-upload</v-icon>
                  Importar .md
                </v-btn>
                <input
                  ref="inputPromptsMd"
                  type="file"
                  accept=".md,text/markdown,text/plain"
                  hidden
                  @change="onImportarPromptsMd"
                />
                <span class="text-caption grey--text">
                  Exporta/importa las 7 secciones con encabezados ## en un solo archivo.
                </span>
              </div>
              <v-tabs v-model="tabPrompt" dense background-color="transparent" class="mb-2">
                <v-tab>Comportamiento</v-tab>
                <v-tab>Comercial</v-tab>
                <v-tab>Etapa</v-tab>
                <v-tab>Objeciones</v-tab>
                <v-tab>Ejemplos</v-tab>
                <v-tab>Núcleo</v-tab>
                <v-tab>Preview</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabPrompt">
                <v-tab-item>
                  <v-textarea
                    v-model="form.prompts.comportamiento.texto"
                    label="Prompt de comportamiento"
                    dense
                    outlined
                    rows="8"
                    :disabled="!editable"
                    hint="Tono, presentación, despedida, estilo…"
                    persistent-hint
                  />
                </v-tab-item>
                <v-tab-item>
                  <v-textarea
                    v-model="form.prompts.comercial.texto"
                    label="Prompt comercial"
                    dense
                    outlined
                    rows="8"
                    :disabled="!editable"
                    hint="Objeciones, CTA, afirmaciones permitidas/prohibidas…"
                    persistent-hint
                  />
                </v-tab-item>
                <v-tab-item>
                  <v-textarea
                    v-model="form.prompts.etapas.calificacion_inicial.texto"
                    label="Etapa calificación inicial (override; vacío = via_prompts/archivo)"
                    dense
                    outlined
                    rows="8"
                    :disabled="!editable"
                  />
                  <div class="text-caption grey--text mt-1">Fallback BD/FS: {{ comercialLabel }}</div>
                </v-tab-item>
                <v-tab-item>
                  <v-textarea
                    v-model="form.prompts.objeciones.texto"
                    label="Objeciones"
                    dense
                    outlined
                    rows="6"
                    :disabled="!editable"
                  />
                </v-tab-item>
                <v-tab-item>
                  <v-textarea
                    v-model="form.prompts.ejemplos.texto"
                    label="Ejemplos (+ / −)"
                    dense
                    outlined
                    rows="6"
                    :disabled="!editable"
                  />
                </v-tab-item>
                <v-tab-item>
                  <v-alert dense type="warning" class="text-caption mb-2">
                    Núcleo protegido. Vacío = usa {{ nucleoLabel }}. Edición técnica requiere marcar el checkbox.
                  </v-alert>
                  <v-checkbox
                    v-model="editarNucleo"
                    dense
                    hide-details
                    label="Soy técnico: editar núcleo (staging)"
                    :disabled="!editable"
                    class="mb-2"
                  />
                  <v-btn
                    small
                    outlined
                    color="indigo"
                    class="mb-2 mr-2"
                    :disabled="!editable || !editarNucleo"
                    :loading="importandoNucleo"
                    @click="importarNucleo"
                  >
                    <v-icon left small>mdi-file-import</v-icon>
                    Importar núcleo desde FS
                  </v-btn>
                  <v-textarea
                    v-model="form.prompts.nucleo.texto"
                    label="Núcleo (texto versionado)"
                    dense
                    outlined
                    rows="8"
                    :disabled="!editable || !editarNucleo"
                  />
                </v-tab-item>
                <v-tab-item>
                  <v-btn small color="primary" class="mb-2" :loading="compilando" @click="previsualizarPrompt">
                    Compilar vista final
                  </v-btn>
                  <div class="text-caption grey--text mb-2">
                    Compila la versión guardada en BD. Guarda el borrador antes si editaste textos.
                  </div>
                  <template v-if="compilado">
                    <v-alert dense outlined type="info" class="mb-2 text-caption">
                      <div>
                        <strong>{{ compilado.id_agente }}</strong>
                        · v{{ compilado.numero_version }}
                        · {{ compilado.estado_version || '—' }}
                        · modo {{ compilado.modo_operacion }}
                        · ~{{ compilado.tokens_estimados || 0 }} tokens
                      </div>
                      <div class="mt-1">
                        Bloques:
                        {{ (compilado.mapa_bloques || []).map(b => b.bloque).join(' → ') || '—' }}
                      </div>
                      <div v-if="(compilado.bloques_vacios || []).length" class="mt-1 orange--text">
                        Vacíos: {{ compilado.bloques_vacios.join(', ') }}
                      </div>
                      <div v-if="(compilado.advertencias || []).length" class="mt-1">
                        Advertencias: {{ compilado.advertencias.join(', ') }}
                      </div>
                    </v-alert>
                    <v-expansion-panels accordion class="mb-2">
                      <v-expansion-panel
                        v-for="(blk, key) in (compilado.bloques_detalle || {})"
                        :key="key"
                      >
                        <v-expansion-panel-header class="text-caption">
                          {{ blk.nombre }}
                          <span class="grey--text ml-2">
                            {{ blk.presente ? (`${blk.tokens_aprox} tok`) : 'vacío' }}
                          </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <pre class="text-caption" style="white-space: pre-wrap; max-height: 200px; overflow: auto">{{ blk.texto || '(vacío / fallback en compilación)' }}</pre>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <v-textarea
                      :value="compilado.prompt_compilado"
                      label="Prompt compilado (completo)"
                      dense
                      outlined
                      rows="10"
                      readonly
                    />
                  </template>
                </v-tab-item>
              </v-tabs-items>
              <v-btn color="primary" small class="mt-3" :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-radio-group v-model="form.modo_operacion" :disabled="!editable" column>
                <v-radio value="autonomo_sandbox" label="Autónomo sandbox — IA genera y puede enviarse (si Auto-enviar)" />
                <v-radio value="auxiliar_humano" label="Auxiliar humano — IA solo sugiere; humano aprueba/edita/envía" />
                <v-radio value="pausado" label="Pausado — no genera" />
              </v-radio-group>
              <v-alert dense outlined type="info" class="text-caption">
                En modo auxiliar la bandeja sandbox no auto-envía aunque el checkbox esté marcado.
              </v-alert>
              <v-btn color="primary" small :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-alert dense outlined type="info" class="mb-2 text-caption">
                Lista vacía = heredar todas las tools globales actuales (recomendado en sandbox).
              </v-alert>
              <v-checkbox
                v-model="heredarTools"
                label="Heredar tools globales (array vacío)"
                dense
                :disabled="!editable"
                hide-details
                class="mb-2"
              />
              <v-select
                v-if="!heredarTools"
                v-model="form.herramientasIds"
                :items="toolsCatalogo"
                label="Tools habilitadas"
                multiple
                chips
                dense
                outlined
                :disabled="!editable"
              />
              <v-btn color="primary" small class="mt-2" :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-text-field
                v-model="form.perfil_modelo.modelo"
                label="Modelo (vacío = .env actual)"
                dense
                outlined
                :disabled="!editable"
                class="mb-2"
              />
              <v-text-field
                v-model.number="form.perfil_modelo.presupuesto_diario"
                label="Presupuesto diario (opcional)"
                type="number"
                dense
                outlined
                :disabled="!editable"
                class="mb-2"
              />
              <v-select
                v-model="form.perfil_modelo.fallback"
                :items="['humano', 'reintento', 'pausa']"
                label="Fallback"
                dense
                outlined
                :disabled="!editable"
              />
              <v-btn color="primary" small class="mt-2" :disabled="!editable" :loading="guardando" @click="guardarBorrador">
                Guardar borrador
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-btn small color="primary" class="mb-3" :loading="validando" @click="validarVersion">
                <v-icon left small>mdi-check-decagram</v-icon>
                Validar versión
              </v-btn>
              <v-alert v-if="validacion" dense :type="validacion.ok ? 'success' : 'error'" class="mb-3">
                {{ validacion.ok ? 'OK para publicar' : (validacion.errores || []).join(', ') }}
              </v-alert>
              <v-checkbox v-model="checklist.marca" label="Una sola marca" dense hide-details />
              <v-checkbox v-model="checklist.nucleo" label="Núcleo protegido no alterado" dense hide-details />
              <v-checkbox v-model="checklist.sandbox" label="Probado en sandbox (manual)" dense hide-details />
              <v-checkbox v-model="checklist.tools" label="Tools heredadas o subset válido" dense hide-details class="mb-3" />
              <v-btn small text :to="{ name: 'twilioSandbox' }" target="_blank">
                <v-icon left small>mdi-open-in-new</v-icon>
                Abrir sandbox para simular
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <v-text-field v-model="motivoPublicar" label="Motivo de publicación / cambio" dense outlined class="mb-3" />
              <div class="d-flex flex-wrap">
                <v-btn small class="mr-2 mb-2" :disabled="!editable" :loading="workflow" @click="enviarRevision">
                  Enviar a revisión
                </v-btn>
                <v-btn small color="indigo" dark class="mr-2 mb-2" :loading="workflow" @click="aprobar">
                  Aprobar
                </v-btn>
                <v-btn small color="error" class="mr-2 mb-2" :loading="workflow" @click="rechazar">
                  Rechazar
                </v-btn>
                <v-btn small color="success" dark class="mb-2" :loading="workflow" @click="publicar">
                  Publicar
                </v-btn>
              </div>
              <div class="text-caption grey--text mt-2">
                Staging permite publicar desde borrador si la validación pasa
                (`VENDEDOR_IA_PUBLICAR_AGENTE_SIN_PRUEBAS`).
              </div>
            </v-tab-item>

            <v-tab-item>
              <v-btn small class="mb-3" :loading="cargandoAud" @click="cargarAuditoria">
                Recargar auditoría
              </v-btn>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Acción</th>
                    <th>Actor</th>
                    <th>Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ev in auditoria" :key="ev.id">
                    <td class="text-caption">{{ formatFecha(ev.fecha_hora) }}</td>
                    <td class="text-caption">{{ ev.accion }}</td>
                    <td class="text-caption">{{ ev.tipo_actor }}</td>
                    <td class="text-caption">{{ resumenAud(ev) }}</td>
                  </tr>
                  <tr v-if="!auditoria.length">
                    <td colspan="4" class="text-caption grey--text">Sin eventos aún</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'AgentesIaAdmin',
  data() {
    return {
      cargando: false,
      guardando: false,
      workflow: false,
      validando: false,
      cargandoAud: false,
      error: null,
      status: null,
      agentes: [],
      toolsCatalogo: [],
      dlgNuevo: false,
      dlgCopiar: false,
      dlgEditor: false,
      copiarOrigen: null,
      seccionesClon: [
        'identidad', 'alcance', 'comportamiento', 'comercial', 'etapas',
        'objeciones', 'ejemplos', 'nucleo', 'modo', 'tools', 'recursos',
        'modelo', 'limites', 'casos_prueba',
      ],
      formCopiar: {
        id_agente_nuevo: '',
        nombre_publico: '',
        secciones: [],
      },
      agenteActivo: null,
      versiones: [],
      numeroEdit: null,
      tab: 0,
      tabPrompt: 0,
      heredarTools: true,
      editarNucleo: false,
      compilando: false,
      importandoNucleo: false,
      compilado: null,
      validacion: null,
      motivoPublicar: '',
      auditoria: [],
      checklist: { marca: true, nucleo: true, sandbox: false, tools: true },
      formNuevo: {
        id_agente: '',
        nombre_publico: '',
        cargo: 'Asesora comercial',
        marca: 'INBI',
        regiones: ['MTY'],
      },
      form: {
        nombre_publico: '',
        cargo: '',
        personalidad: {},
        alcance: { marca: 'INBI', regiones: [] },
        perfil_modelo: { modelo: null, presupuesto_diario: null, fallback: 'humano' },
        herramientasIds: [],
        modo_operacion: 'autonomo_sandbox',
        prompts: {
          nucleo: { texto: '', protegido: true },
          comportamiento: { texto: '' },
          comercial: { texto: '' },
          etapas: { calificacion_inicial: { texto: '' } },
          objeciones: { texto: '' },
          ejemplos: { texto: '' },
        },
      },
      headers: [
        { text: 'Nombre', value: 'nombre_publico' },
        { text: 'Id', value: 'id_agente' },
        { text: 'Marca', value: 'marca' },
        { text: 'Regiones', value: 'regiones', sortable: false },
        { text: 'Estado', value: 'estado_agente' },
        { text: 'Ver. pub', value: 'version' },
        { text: '', value: 'actions', sortable: false },
      ],
      opcionesRegiones: ['MTY', 'CDMX', 'GDL'],
      opcionesTono: ['cercano', 'profesional', 'energico', 'calido'],
      opcionesNivel: ['bajo', 'medio', 'alto'],
      opcionesEmojis: ['ninguno', 'poco', 'moderado', 'frecuente'],
      opcionesLongitud: ['corto', 'medio', 'largo'],
      opcionesEstilo: ['consultiva', 'directa', 'suave'],
    }
  },
  computed: {
    versionEdit() {
      if (this.numeroEdit == null) return null
      return (this.versiones || []).find((v) => Number(v.numero_version) === Number(this.numeroEdit)) || null
    },
    editable() {
      const e = this.versionEdit && this.versionEdit.estado_version
      return e === 'borrador' || e === 'rechazado'
    },
    versionesSelect() {
      return (this.versiones || []).map((v) => ({
        text: `v${v.numero_version} · ${v.estado_version}`,
        value: v.numero_version,
      }))
    },
    nucleoLabel() {
      const v = this.versionEdit
      if (!v) return '—'
      return `${v.id_prompt_nucleo || 'INBI_NUCLEO_SISTEMA'} @ ${v.version_prompt_nucleo || 'v1'}`
    },
    comercialLabel() {
      const v = this.versionEdit
      if (!v) return '—'
      return `${v.id_prompt_comercial || '—'} @ ${v.version_prompt_comercial || '—'}`
    },
  },
  watch: {
    numeroEdit() {
      this.sincronizarFormDesdeVersion()
      this.validacion = null
    },
    heredarTools(val) {
      if (val) this.form.herramientasIds = []
    },
  },
  created() {
    this.cargarListado()
    this.cargarTools()
    if (this.$route.params.id) {
      this.abrirAgente({ id_agente: this.$route.params.id })
    }
  },
  methods: {
    chipEstado(e) {
      const m = {
        activo: 'green',
        publicado: 'green',
        borrador: 'grey',
        en_revision: 'orange',
        aprobado: 'indigo',
        rechazado: 'red',
        inactivo: 'brown',
        archivado: 'blue-grey',
      }
      return m[e] || 'grey'
    },
    regionesTexto(item) {
      const r = (item.version_publicada && item.version_publicada.alcance && item.version_publicada.alcance.regiones)
        || (item.region_legacy ? [item.region_legacy] : [])
      return (r && r.length) ? r.join(', ') : '—'
    },
    toast(mensaje, tipo = 'success') {
      this.$store.commit('mostrarAlerta', { tipo, mensaje })
    },
    errMsg(e) {
      return (e && e.response && e.response.data && e.response.data.message)
        || (e && e.message)
        || 'Error'
    },
    async cargarListado() {
      this.cargando = true
      this.error = null
      try {
        const [st, ag] = await Promise.all([
          this.$http.get('vendedor-ia.agentes.status'),
          this.$http.get('vendedor-ia.agentes'),
        ])
        this.status = st.data
        this.agentes = (ag.data && ag.data.agentes) || []
      } catch (e) {
        this.error = this.errMsg(e)
      } finally {
        this.cargando = false
      }
    },
    async cargarTools() {
      try {
        const res = await this.$http.get('vendedor-ia.herramientas')
        const lista = (res.data && (res.data.herramientas || res.data.tools || res.data)) || []
        const arr = Array.isArray(lista) ? lista : []
        this.toolsCatalogo = arr.map((t) => (typeof t === 'string' ? t : (t.id || t.nombre))).filter(Boolean)
      } catch (_) {
        this.toolsCatalogo = []
      }
    },
    abrirNuevo() {
      this.formNuevo = {
        id_agente: '',
        nombre_publico: '',
        cargo: 'Asesora comercial',
        marca: 'INBI',
        regiones: ['MTY'],
      }
      this.dlgNuevo = true
    },
    async crearAgente() {
      this.guardando = true
      try {
        const res = await this.$http.post('vendedor-ia.agentes', this.formNuevo)
        this.toast('Agente creado')
        this.dlgNuevo = false
        await this.cargarListado()
        if (res.data && res.data.agente) this.abrirAgente(res.data.agente)
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.guardando = false
      }
    },
    async abrirAgente(item) {
      const id = item.id_agente || item.id
      try {
        const [ag, ver] = await Promise.all([
          this.$http.get(`vendedor-ia.agentes/${id}`),
          this.$http.get(`vendedor-ia.agentes/${id}/versiones`),
        ])
        this.agenteActivo = ag.data.agente
        this.versiones = (ver.data && ver.data.versiones) || []
        const borrador = this.versiones.find((v) => ['borrador', 'rechazado'].includes(v.estado_version))
        this.numeroEdit = (borrador && borrador.numero_version)
          || (this.agenteActivo.version_publicada && this.agenteActivo.version_publicada.numero_version)
          || (this.versiones[0] && this.versiones[0].numero_version)
          || null
        this.sincronizarFormDesdeVersion()
        this.dlgEditor = true
        this.tab = 0
        this.$router.replace({ name: 'vendedorIaAgentes', params: { id } }).catch(() => {})
        this.cargarAuditoria()
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      }
    },
    cerrarEditor() {
      this.dlgEditor = false
      this.agenteActivo = null
      this.$router.replace({ name: 'vendedorIaAgentes' }).catch(() => {})
      this.cargarListado()
    },
    sincronizarFormDesdeVersion() {
      const v = this.versionEdit
      const a = this.agenteActivo
      if (!v || !a) return
      const p = v.personalidad || {}
      const alc = v.alcance || {}
      const tools = Array.isArray(v.herramientas) ? v.herramientas : []
      const pr = v.prompts || {}
      this.heredarTools = tools.length === 0
      this.editarNucleo = false
      this.compilado = null
      this.form = {
        nombre_publico: a.nombre_publico,
        cargo: a.cargo,
        personalidad: {
          tono: p.tono || 'cercano',
          formalidad: p.formalidad || 'medio',
          uso_emojis: p.uso_emojis || 'moderado',
          longitud_respuesta: p.longitud_respuesta || 'corto',
          estilo_venta: p.estilo_venta || 'consultiva',
          nivel_energia: p.nivel_energia || 'suave',
          tratamiento_prospecto: p.tratamiento_prospecto || 'adaptativo',
          instrucciones_escritura: p.instrucciones_escritura || '',
        },
        alcance: {
          marca: alc.marca || a.marca || 'INBI',
          regiones: Array.isArray(alc.regiones) ? [...alc.regiones] : [],
        },
        perfil_modelo: {
          modelo: (v.perfil_modelo && v.perfil_modelo.modelo) || null,
          presupuesto_diario: (v.perfil_modelo && v.perfil_modelo.presupuesto_diario) || null,
          fallback: (v.perfil_modelo && v.perfil_modelo.fallback) || 'humano',
        },
        herramientasIds: tools.map((t) => (typeof t === 'string' ? t : t.id_tool || t.id)).filter(Boolean),
        modo_operacion: v.modo_operacion || 'autonomo_sandbox',
        prompts: {
          nucleo: { texto: (pr.nucleo && pr.nucleo.texto) || '', protegido: true },
          comportamiento: { texto: (pr.comportamiento && pr.comportamiento.texto) || '' },
          comercial: { texto: (pr.comercial && pr.comercial.texto) || '' },
          etapas: {
            calificacion_inicial: {
              texto: (pr.etapas && pr.etapas.calificacion_inicial && pr.etapas.calificacion_inicial.texto) || '',
            },
          },
          objeciones: { texto: (pr.objeciones && pr.objeciones.texto) || '' },
          ejemplos: { texto: (pr.ejemplos && pr.ejemplos.texto) || '' },
        },
      }
    },
    payloadBorrador() {
      const herramientas = this.heredarTools
        ? []
        : this.form.herramientasIds.map((id) => ({ id_tool: id, nivel_permiso: 'usar_en_respuesta' }))
      const pers = { ...(this.form.personalidad || {}) }
      const mini = String(pers.instrucciones_escritura || '').trim().slice(0, 800)
      pers.instrucciones_escritura = mini || null
      return {
        numero_version: this.numeroEdit,
        nombre_publico: this.form.nombre_publico,
        cargo: this.form.cargo,
        personalidad: pers,
        alcance: this.form.alcance,
        perfil_modelo: this.form.perfil_modelo,
        herramientas,
        modo_operacion: this.form.modo_operacion,
        prompts: this.form.prompts,
        editar_nucleo: !!this.editarNucleo,
      }
    },
    recortarMiniPrompt(val) {
      const t = String(val == null ? '' : val)
      if (t.length > 800) {
        this.form.personalidad.instrucciones_escritura = t.slice(0, 800)
      }
    },
    async previsualizarPrompt() {
      if (!this.agenteActivo || this.numeroEdit == null) return
      this.compilando = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.get(
          `vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/prompt-compilado`,
        )
        this.compilado = res.data || res.body || null
        this.tabPrompt = 6
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.compilando = false
      }
    },
    textoPromptEtapa() {
      const et = this.form.prompts && this.form.prompts.etapas
      const cal = et && et.calificacion_inicial
      return (cal && cal.texto) || ''
    },
    construirMarkdownPrompts() {
      const id = (this.agenteActivo && this.agenteActivo.id_agente) || 'agente'
      const nombre = this.form.nombre_publico || id
      const ver = this.numeroEdit != null ? `v${this.numeroEdit}` : 'sin-version'
      const pr = this.form.prompts || {}
      const secciones = [
        { titulo: 'COMPORTAMIENTO', texto: (pr.comportamiento && pr.comportamiento.texto) || '' },
        { titulo: 'COMERCIAL', texto: (pr.comercial && pr.comercial.texto) || '' },
        { titulo: 'ETAPA', texto: this.textoPromptEtapa() },
        { titulo: 'OBJECIONES', texto: (pr.objeciones && pr.objeciones.texto) || '' },
        { titulo: 'EJEMPLOS', texto: (pr.ejemplos && pr.ejemplos.texto) || '' },
        { titulo: 'NÚCLEO', texto: (pr.nucleo && pr.nucleo.texto) || '' },
        {
          titulo: 'PREVIEW',
          texto: (this.compilado && this.compilado.prompt_compilado) || '',
        },
      ]
      const lines = [
        `# Prompts — ${nombre} (${id}) ${ver}`,
        '',
        '> Archivo exportado desde Administrar agentes.',
        '> Al importar, el contenido se reparte por los encabezados `##` siguientes.',
        '> La sección PREVIEW es solo lectura (no se aplica al importar).',
        '',
      ]
      secciones.forEach((s) => {
        lines.push(`## ${s.titulo}`)
        lines.push('')
        lines.push(String(s.texto || '').trimEnd())
        lines.push('')
      })
      return lines.join('\n')
    },
    exportarPromptsMd() {
      const id = (this.agenteActivo && this.agenteActivo.id_agente) || 'agente'
      const ver = this.numeroEdit != null ? `v${this.numeroEdit}` : 'borrador'
      const stamp = new Date().toISOString().slice(0, 10)
      const md = this.construirMarkdownPrompts()
      const blob = new Blob([md], { type: 'text/markdown;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `prompts-${id}-${ver}-${stamp}.md`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
      this.toast('Prompts descargados en .md')
    },
    triggerImportarPromptsMd() {
      if (!this.editable) {
        this.toast('Solo se pueden importar prompts en borrador/rechazado', 'error')
        return
      }
      const input = this.$refs.inputPromptsMd
      if (input) {
        input.value = ''
        input.click()
      }
    },
    normalizarClaveSeccionPrompt(titulo) {
      return String(titulo || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '_')
        .replace(/^_|_$/g, '')
    },
    parsearMarkdownPrompts(md) {
      const texto = String(md || '').replace(/\r\n/g, '\n')
      const mapa = {}
      const conocidos = 'COMPORTAMIENTO|COMERCIAL|ETAPA|ETAPAS|CALIFICACION_INICIAL|OBJECIONES|EJEMPLOS|N[UÚ]CLEO|PREVIEW|PROMPT_COMPILADO'
      const re = new RegExp(`^##\\s+(${conocidos})\\s*$`, 'gmi')
      const matches = []
      let m
      while ((m = re.exec(texto)) !== null) {
        matches.push({ titulo: m[1], index: m.index, headerEnd: m.index + m[0].length })
      }
      matches.forEach((item, i) => {
        const fin = i + 1 < matches.length ? matches[i + 1].index : texto.length
        const cuerpo = texto.slice(item.headerEnd, fin).replace(/^\n+/, '').replace(/\n+$/, '')
        const clave = this.normalizarClaveSeccionPrompt(item.titulo)
        if (clave) mapa[clave] = cuerpo
      })
      return mapa
    },
    aplicarPromptsImportados(mapa) {
      const alias = {
        COMPORTAMIENTO: 'comportamiento',
        COMERCIAL: 'comercial',
        ETAPA: 'etapa',
        ETAPAS: 'etapa',
        CALIFICACION_INICIAL: 'etapa',
        OBJECIONES: 'objeciones',
        EJEMPLOS: 'ejemplos',
        NUCLEO: 'nucleo',
        PREVIEW: 'preview',
        PROMPT_COMPILADO: 'preview',
      }
      const aplicados = []
      const omitidos = []
      Object.keys(mapa).forEach((clave) => {
        const destino = alias[clave]
        const valor = mapa[clave]
        if (!destino) {
          omitidos.push(clave)
          return
        }
        if (destino === 'preview') {
          omitidos.push('PREVIEW (solo lectura)')
          return
        }
        if (destino === 'comportamiento') {
          this.$set(this.form.prompts.comportamiento, 'texto', valor)
          aplicados.push('Comportamiento')
        } else if (destino === 'comercial') {
          this.$set(this.form.prompts.comercial, 'texto', valor)
          aplicados.push('Comercial')
        } else if (destino === 'etapa') {
          if (!this.form.prompts.etapas) this.$set(this.form.prompts, 'etapas', {})
          if (!this.form.prompts.etapas.calificacion_inicial) {
            this.$set(this.form.prompts.etapas, 'calificacion_inicial', { texto: '' })
          }
          this.$set(this.form.prompts.etapas.calificacion_inicial, 'texto', valor)
          aplicados.push('Etapa')
        } else if (destino === 'objeciones') {
          this.$set(this.form.prompts.objeciones, 'texto', valor)
          aplicados.push('Objeciones')
        } else if (destino === 'ejemplos') {
          this.$set(this.form.prompts.ejemplos, 'texto', valor)
          aplicados.push('Ejemplos')
        } else if (destino === 'nucleo') {
          this.editarNucleo = true
          this.$set(this.form.prompts.nucleo, 'texto', valor)
          aplicados.push('Núcleo')
        }
      })
      return { aplicados, omitidos }
    },
    onImportarPromptsMd(ev) {
      const file = ev.target && ev.target.files && ev.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = () => {
        try {
          const mapa = this.parsearMarkdownPrompts(reader.result)
          const claves = Object.keys(mapa)
          if (!claves.length) {
            this.toast('No se encontraron secciones ## en el archivo', 'error')
            return
          }
          const { aplicados, omitidos } = this.aplicarPromptsImportados(mapa)
          if (!aplicados.length) {
            this.toast('Ninguna sección reconocida para aplicar', 'error')
            return
          }
          let msg = `Importados: ${aplicados.join(', ')}`
          if (omitidos.length) msg += `. Omitidos: ${omitidos.join(', ')}`
          this.toast(msg)
          this.tabPrompt = 0
        } catch (e) {
          this.toast(e.message || 'Error al importar .md', 'error')
        }
      }
      reader.onerror = () => this.toast('No se pudo leer el archivo', 'error')
      reader.readAsText(file, 'UTF-8')
    },
    async importarNucleo() {
      if (!this.editable || !this.editarNucleo) {
        this.toast('Marca edición técnica del núcleo primero', 'error')
        return
      }
      if (!window.confirm('¿Importar 00_nucleo_sistema.md a esta versión borrador?')) return
      this.importandoNucleo = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.post(`vendedor-ia.agentes/${id}/nucleo/importar`, {
          numero_version: this.numeroEdit,
          editar_nucleo: true,
        })
        const payload = res.data || res.body || {}
        if (payload.version) {
          const idx = this.versiones.findIndex((v) => v.numero_version === payload.version.numero_version)
          if (idx >= 0) this.$set(this.versiones, idx, payload.version)
        }
        if (payload.agente) this.agenteActivo = payload.agente
        this.sincronizarFormDesdeVersion()
        this.editarNucleo = true
        this.toast('Núcleo importado y versionado')
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.importandoNucleo = false
      }
    },
    async guardarBorrador() {
      if (!this.editable) {
        this.toast('Solo se editan borrador/rechazado. Crea una versión nueva.', 'error')
        return
      }
      this.guardando = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.put(`vendedor-ia.agentes/${id}/borrador`, this.payloadBorrador())
        this.agenteActivo = res.data.agente || this.agenteActivo
        if (res.data.version) {
          const idx = this.versiones.findIndex((v) => v.numero_version === res.data.version.numero_version)
          if (idx >= 0) this.$set(this.versiones, idx, res.data.version)
        }
        this.toast('Borrador guardado')
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.guardando = false
      }
    },
    async crearVersion() {
      this.guardando = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.post(`vendedor-ia.agentes/${id}/versiones`, {
          motivo_cambio: 'nueva_version_ui',
        })
        const ver = await this.$http.get(`vendedor-ia.agentes/${id}/versiones`)
        this.versiones = (ver.data && ver.data.versiones) || []
        this.numeroEdit = res.data.version.numero_version
        this.toast(`Versión ${this.numeroEdit} creada`)
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.guardando = false
      }
    },
    async validarVersion() {
      this.validando = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.post(`vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/validar`)
        this.validacion = res.data
      } catch (e) {
        this.validacion = { ok: false, errores: [this.errMsg(e)] }
      } finally {
        this.validando = false
      }
    },
    async enviarRevision() {
      this.workflow = true
      try {
        const id = this.agenteActivo.id_agente
        await this.$http.post(`vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/revision`, {
          resultado_pruebas: { ok: this.checklist.sandbox || this.checklist.marca },
        })
        await this.refrescarVersiones()
        this.toast('Enviado a revisión')
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.workflow = false
      }
    },
    async aprobar() {
      this.workflow = true
      try {
        const id = this.agenteActivo.id_agente
        await this.$http.post(`vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/aprobar`)
        await this.refrescarVersiones()
        this.toast('Versión aprobada')
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.workflow = false
      }
    },
    async rechazar() {
      const motivo = window.prompt('Motivo de rechazo:')
      if (!motivo) return
      this.workflow = true
      try {
        const id = this.agenteActivo.id_agente
        await this.$http.post(`vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/rechazar`, {
          motivo_rechazo: motivo,
        })
        await this.refrescarVersiones()
        this.toast('Versión rechazada')
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.workflow = false
      }
    },
    async publicar() {
      if (!this.motivoPublicar || !String(this.motivoPublicar).trim()) {
        this.toast('Indica un motivo de publicación', 'error')
        return
      }
      this.workflow = true
      try {
        const id = this.agenteActivo.id_agente
        const res = await this.$http.post(
          `vendedor-ia.agentes/${id}/versiones/${this.numeroEdit}/publicar`,
          {
            motivo_cambio: this.motivoPublicar,
            resultado_pruebas: { ok: true, checklist: this.checklist },
          },
        )
        this.agenteActivo = res.data.agente || this.agenteActivo
        await this.refrescarVersiones()
        this.toast('Versión publicada. Conversaciones nuevas usarán esta versión (flag ON).')
        this.cargarAuditoria()
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.workflow = false
      }
    },
    async refrescarVersiones() {
      const id = this.agenteActivo.id_agente
      const [ag, ver] = await Promise.all([
        this.$http.get(`vendedor-ia.agentes/${id}`),
        this.$http.get(`vendedor-ia.agentes/${id}/versiones`),
      ])
      this.agenteActivo = ag.data.agente
      this.versiones = (ver.data && ver.data.versiones) || []
      this.sincronizarFormDesdeVersion()
    },
    async clonar(item) {
      this.abrirCopiar(item)
    },
    abrirCopiar(item) {
      this.copiarOrigen = item
      this.formCopiar = {
        id_agente_nuevo: `${item.id_agente}_COPIA`,
        nombre_publico: `${item.nombre_publico || item.id_agente} (copia)`,
        secciones: [...this.seccionesClon],
      }
      this.dlgCopiar = true
    },
    seleccionarTodasSecciones(todas) {
      this.formCopiar.secciones = todas ? [...this.seccionesClon] : []
    },
    async ejecutarCopiar() {
      if (!this.copiarOrigen) return
      const idNuevo = String(this.formCopiar.id_agente_nuevo || '').trim()
      if (!idNuevo) {
        this.toast('id_agente nuevo requerido', 'error')
        return
      }
      this.guardando = true
      try {
        const res = await this.$http.post(
          `vendedor-ia.agentes/${this.copiarOrigen.id_agente}/clonar`,
          {
            id_agente_nuevo: idNuevo,
            nombre_publico: this.formCopiar.nombre_publico,
            secciones: this.formCopiar.secciones,
          },
        )
        this.toast('Agente copiado (borrador v1)')
        this.dlgCopiar = false
        await this.cargarListado()
        const creado = res.data && res.data.agente
        if (creado) this.abrirAgente(creado)
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      } finally {
        this.guardando = false
      }
    },
    async desactivar(item) {
      if (!window.confirm(`¿Desactivar ${item.id_agente}?`)) return
      try {
        await this.$http.post(`vendedor-ia.agentes/${item.id_agente}/desactivar`)
        this.toast('Agente desactivado')
        this.cargarListado()
        if (this.agenteActivo && this.agenteActivo.id_agente === item.id_agente) {
          const ag = await this.$http.get(`vendedor-ia.agentes/${item.id_agente}`)
          this.agenteActivo = ag.data.agente
        }
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      }
    },
    async activar(item) {
      try {
        await this.$http.post(`vendedor-ia.agentes/${item.id_agente}/activar`)
        this.toast('Agente activado')
        this.cargarListado()
        if (this.agenteActivo && this.agenteActivo.id_agente === item.id_agente) {
          const ag = await this.$http.get(`vendedor-ia.agentes/${item.id_agente}`)
          this.agenteActivo = ag.data.agente
        }
      } catch (e) {
        this.toast(this.errMsg(e), 'error')
      }
    },
    async cargarAuditoria() {
      if (!this.agenteActivo) return
      this.cargandoAud = true
      try {
        const res = await this.$http.get(
          `vendedor-ia.agentes/${this.agenteActivo.id_agente}/auditoria`,
          { params: { limit: 40 } },
        )
        this.auditoria = (res.data && res.data.eventos) || []
      } catch (_) {
        this.auditoria = []
      } finally {
        this.cargandoAud = false
      }
    },
    formatFecha(f) {
      if (!f) return '—'
      try { return new Date(f).toLocaleString() } catch (_) { return String(f) }
    },
    resumenAud(ev) {
      const d = ev.datos_nuevos || {}
      const parts = []
      if (d.numero_version != null) parts.push(`v${d.numero_version}`)
      if (d.estado) parts.push(d.estado)
      if (d.motivo_cambio) parts.push(d.motivo_cambio)
      return parts.join(' · ') || '—'
    },
  },
}
</script>
